import { connect } from "react-redux"

import BulkActionsSelectButton from "app/static/frontend/search-new/components/BulkActions/buttons/BulkActionsSelectButton"

import {
    selectCurrentCount,
    selectIsCountLoading,
} from "shared/search/selectors"

import {
    bulkActionsSelectAll,
    clearBulkActionsSelections,
} from "shared/search/searchify/bulkactions/action-creators"

import {
    selectBulkActionsCount,
    selectBulkActionsSelectButtonLabel
} from "shared/search/searchify/bulkactions/selectors"

const mapStateToProps = (state, props) => ({
    bulkActionsCount: selectBulkActionsCount(state, props),
    currentCount: selectCurrentCount(state, props),
    isCountLoading: selectIsCountLoading(state, props),
    selectButtonLabel: selectBulkActionsSelectButtonLabel(state, props)
})

const mapDispatchToProps = {
    bulkActionsSelectAll,
    clearBulkActionsSelections,
}

export default connect(mapStateToProps, mapDispatchToProps)(BulkActionsSelectButton)
